export enum ModuleFeatureEnum {
  Unknown = 0,
  Order = 1 << 0,
  CauseOfDelay = Order << 1,
  OrderCauseOfDelay = Order | CauseOfDelay,
  ShowInstructionDoc = CauseOfDelay << 1,
}
